module.exports = __webpack_public_path__ + "static/media/garages-agréés-icon.e4e4ff0c.svg";